import yup from 'src/libraries/validator.library';

export const EmployeeSchema = yup
  .object({
    lan_user_id: yup.string(),
    emp_no: yup.string().required(),
    contactType_id: yup.number(),
    contactType: yup.string(),
    first_name: yup.string(),
    middle_name: yup.string().nullable(),
    last_name: yup.string(),
    company_name: yup.string(),
    job_title: yup.string(),
    e_mail_address: yup.string().email().nullable(),
    dept_org_desc: yup.string(),
    work_phone_1: yup.string().nullable(),
    mgr_first_name: yup.string().nullable(),
    mgr_last_name: yup.string().nullable(),
    mgr_e_mail_address: yup.string().nullable(),
  })
  .defined();

export const EmployeeListSchema = yup.array().of(EmployeeSchema).defined();

export const EmployeeSearchSchema = yup
  .object({
    EMPNO: yup.string(),
    FIRST_NAME: yup.string(),
    LAST_NAME: yup.string(),
    E_MAIL_ADDRESS: yup.string().nullable(),
    JOB_TITLE: yup.string().nullable(),
    COMPANY_NAME: yup.string().nullable(),
    DEPT_ORG_DESC: yup.string().nullable(),
    WORK_PHONE_1: yup.string().nullable(),
    MGR_FIRST_NAME: yup.string().nullable(),
    MGR_E_MAIL_ADDRESS: yup.string().nullable(),
    MGR_LAST_NAME: yup.string().nullable(),
  })
  .defined();

export const EmployeeSearchPayloadSchema = yup
  .array()
  .of(EmployeeSearchSchema)
  .defined();

export const EmployeeSearchFormSchema = yup
  .object({
    employeeNos: yup.array().of(yup.string()),
    eMailIds: yup.array().of(yup.string()),
    firstNames: yup.array().of(yup.string()),
  })
  .defined();

export const EmployeeUsersPayloadSchema = yup
  .object({
    count: yup.number(),
    rows: yup.array().of(EmployeeSearchSchema).defined(),
  })
  .defined();

const EmployeeSearchInternalSchema = yup
  .object({
    empNo: yup.string(),
    firstName: yup.string(),
    lastName: yup.string(),
    middleName: yup.string().nullable(),
    emailAddress: yup.string().nullable(),
    companyName: yup.string().nullable(),
  })
  .defined();

export const EmployeeSearchInternalPayloadSchema = yup
  .object({
    employees: yup.array().of(EmployeeSearchInternalSchema.clone()).defined(),
  })
  .defined();

export const EmployeesDetailsSchema = yup
  .object({
    count: yup.number().optional(),
    rows: yup
      .array()
      .of(
        yup
          .object({
            EMPNO: yup.string(),
            FIRST_NAME: yup.string(),
            MIDDLE_NAME: yup.string().nullable(),
            LAST_NAME: yup.string(),
            COMPANY_NAME: yup.string(),
            PERS_STATUS: yup.string().nullable(),
            ORG_CODE: yup.string(),
            JOB_CODE: yup.string().nullable(),
            JOB_TITLE: yup.string(),
            MAILSTOP_ID: yup.string(),
            LOCATION_ID: yup.string(),
            LOCATION_NAME: yup.string(),
            E_MAIL_ADDRESS: yup.string().nullable(),
            DEPT_ORG_CODE: yup.string(),
            DEPT_ORG_DESC: yup.string(),
            DIV_ORG_CODE: yup.string(),
            MGR_FIRST_NAME: yup.string(),
            MGR_EMPNO: yup.string(),
            MGR_LAST_NAME: yup.string(),
            MGR_WORK_PHONE_1: yup.string().nullable(),
          })
          .defined()
      )
      .defined(),
  })
  .defined();

export const EmployeeDetailsSchema = yup
  .object({
    Employee: yup
      .object({
        lan_user_id: yup.string(),
        emp_no: yup.string(),
        first_name: yup.string(),
        middle_name: yup.string().nullable(),
        last_name: yup.string(),
        company_name: yup.string(),
        pers_status: yup.string().nullable(),
        ord_code: yup.string(),
        job_code: yup.string().nullable(),
        job_title: yup.string(),
        mailstop_id: yup.string(),
        location_id: yup.string(),
        location_name: yup.string(),
        e_mail_address: yup.string().nullable(),
        dept_org_code: yup.string(),
        dept_org_desc: yup.string(),
        div_org_code: yup.string(),
        mgr_first_name: yup.string(),
        mgr_empno: yup.string(),
        mgr_last_name: yup.string(),
        mgr_work_phone_1: yup.string().nullable(),
      })
      .defined(),
  })
  .defined();

export type IEmployee = yup.InferType<typeof EmployeeSchema>;
export type IEmployeeSearch = yup.InferType<typeof EmployeeSearchSchema>;
export type IEmployeeSearchForm = yup.InferType<
  typeof EmployeeSearchFormSchema
>;
export type IEmployeeSearchInternal = yup.InferType<
  typeof EmployeeSearchInternalSchema
>;
export type IEmployeesDetails = yup.InferType<typeof EmployeesDetailsSchema>;
export type IEmployeeDetails = yup.InferType<typeof EmployeeDetailsSchema>;
